/* ========== src/i18n.js ========== */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    debug: false,
    interpolation: { escapeValue: false },
    resources: {
      /* ─────────────────── ENGLISH ─────────────────── */
      en: {
        translation: {
          /* ─── NAVBAR ─── */

          // English
          navHome: "Home",
          navMission: "Our Mission",
          navFounder: "Founder",
          navStudentSpace: "Student Space",
          navAbout: "About",
          navBooks: "Books",
          navEvents: "Events",
          navJoin: "Join Us",
          navContact: "Contact",
          navBlog: "Blog",

          /* ─── HOME ─── */
          // ─── HOME ───
          homeTagline1: "1 in 5 students is neurodivergent.",
          homeTagline2: "Inclusion is not extra — it’s essential.",
          homeTagline3: "Every child deserves to feel seen.",
          homeWelcomeTitle: "Reimagining Education for Every Child",
          homeWelcomeText: "Because no one is broken. Join us in building classrooms that see every child, not as a problem to fix, but as a story to understand.",
          homeGalleryTitle: "📸 Voices & Moments from the Movement",
          homeWatchTitle: "🎥 Watch Our Videos",
          homeWatchDesc: "Explore our message through powerful visual stories and educator insights.",
          homeExploreBtn: "Explore the Toolkit",
          homeAuthorBtn: "Meet the Author",      // legacy label
          homeFounderBtn: "Meet the Founder",    // new label
          homeStudentSpaceBtn: "Dear Student Space",
          homeVideoBtn: "Watch Our Movement Video",

          // ─── MISSION & VISION (English) ───
          missionVisionTitle: "Mission & Vision",

          missionHeading: "Our Mission",
          missionIntro:
          "The mission of the #MyDearTeacher Movement is to transform global education systems by championing inclusive, compassionate, and neurodiversity-affirming practices. We equip educators, schools, and communities with the tools, understanding, and mindset necessary to ensure every child is seen, supported, and celebrated.",
          missionPoint1:
          "Empower educators through practical, evidence-based strategies for inclusive education and special-needs support.",
          missionPoint2:
          "Elevate the voices of neurodivergent, gifted, and twice-exceptional learners who are often misunderstood or marginalised.",
          missionPoint3:
          "Advocate globally for equitable education policies, school-wide inclusion frameworks, and sustainable teacher training.",
          missionPoint4:
          "Create safe emotional spaces where educators feel respected and students feel valued.",
          missionPoint5:
          "Celebrate the teaching profession as a sacred calling, teachers are nurturers, protectors, and frontline advocates.",
          missionClosing:
          "Inclusive education is a human right, not a luxury. Our work bridges research and real-life classrooms so no teacher feels alone and no child feels broken.",

          visionHeading: "Our Vision",
          visionIntro:
          "We envision a global education ecosystem where inclusion is a foundational principle guiding every lesson, policy, and interaction.",
          visionPoint1:
          "Neurodiverse learners thrive in schools that recognise their potential and provide tailored pathways to success.",
          visionPoint2:
          "Educators are fully supported with emotional, psychological, and professional resources to prevent burnout.",
          visionPoint3:
          "Parents and communities partner in the learning journey, fostering trust, advocacy, and empowerment.",
          visionPoint4:
          "School systems shift from one-size-fits-all models to flexible, human-centred frameworks aligned with Universal Design for Learning.",
          visionPoint5:
          "Societies value emotional intelligence and neurodivergence as diversity to be honoured.",
          visionSDGIntro:
          "We support the UN Sustainable Development Goals:",
          sdg4:
          "Quality Education – inclusive and equitable learning opportunities for all.",
          sdg10:
          "Reduced Inequalities – empower marginalised groups and remove systemic barriers.",
          visionClosing:
          "We see classrooms on every continent, rural or urban, public or private, where the message is clear: Every child belongs. Every teacher matters. Every voice counts.",

          /* ─── ABOUT ─── */
         // ─── ABOUT (English) ───
          aboutTitle: "About #MyDearTeacher Movement",
          aboutIntro:
            "The #MyDearTeacher Movement is a global initiative transforming how the world sees, supports, and celebrates neurodiverse learners.",
          aboutFounderName: "Ambassador Beauty Tommy, M.Ed",
          aboutFounderCred1: "UN Peace Ambassador",
          aboutFounderCred2: "Educational Psychologist",
          aboutFounderCred3: "Inclusion Advocate",

          aboutOriginTitle: "📘 Our Story",
          aboutTimeline2019:
            "2019 – The heartfelt poem “Dear Teacher, I Am Not Broken” sparked a global conversation on neurodiversity.",
          aboutTimeline2022:
            "2022 – Piloted partnerships with 40+ schools across Africa and the Middle East to embed inclusive frameworks.",
          aboutTimeline2025:
            "2025 – Launched the #MyDearTeacher Toolkit and Dear Student Space, empowering over 10,000 educators worldwide.",

          aboutMissionTitle: "🎯 Our Mission",
          aboutMission:
            "To equip and inspire educators to teach with compassion and confidence so that every student can thrive in inclusive, supportive environments.",

          aboutVisionTitle: "👁 Our Vision",
          aboutVision:
            "A future where no learner is labeled as broken and every classroom becomes a place of belonging, growth, and possibility.",

          aboutSDGTitle: "🌐 Global Impact & SDG Goals",
          aboutImpactLabel: "Impact snapshot:",
          aboutImpactStat1: "📚 25,000+ books distributed to classrooms",
          aboutImpactStat2: "👩‍🏫 12,000+ teachers trained in inclusive practices",

          aboutWorkTitle: "💼 What We Do",
          aboutBooks: "📚 Books & Publications – tools that spark dialogue",
          aboutTraining: "👩🏽‍🏫 Educator Training & Inclusion Toolkits",
          aboutCampaigns: "🎤 Campaigns & Advocacy – digital and live",
          aboutPartnerships: "🏫 School Inclusion Partnerships",
          aboutEngagement: "📣 Youth & Parent Engagement – voices that matter",

          aboutPartnersTitle: "🤝 Why Partnerships Matter",
          aboutPartners:
            "Change happens through collaboration with schools, NGOs, special-needs centers, and UN-aligned bodies.",

          aboutJoinTitle: "🌟 Join the Journey",
          aboutOffer1: "Professional development programs",
          aboutOffer2: "Inclusive consulting and frameworks",
          aboutOffer3: "Global visibility through campaigns",
          aboutOffer4: "Research-based advocacy grounded in real life",

          /* ─── FOUNDER ─── */
        // ─── FOUNDER ───

          // English
          founderTitle: "About the Founder",
          founderTagline: "Amb. Beauty Tommy, M.Ed | RBT | IBT | SEN Educator | Inclusion Advocate | SDG Ambassador",
          founderBioIntro:
            "Ambassador Beauty Tommy is a globally recognized Educational Psychologist, Guidance Counsellor, and Inclusion Advocate with vast experience transforming education systems to serve every learner with dignity and compassion. She is the visionary founder of the #MyDearTeacher Movement, a global initiative dedicated to empowering teachers and advocating for neurodiverse learners across homes, schools, and societies.",

          founderCredHeading: "🎓 Professional Credentials & Certifications",
          founderCredList: `• ✅ Registered Behaviour Technician (RBT)
          • ✅ International Behaviour Therapist (IBT)
          • ✅ Diploma in Cognitive Behavioural Therapy
          • ✅ Diploma in Positive Psychology
          • ✅ Diploma in Child Psychology
          • ✅ KHDA-Approved Diplomas in Special Educational Needs (SEN) & Early Years Education (EYE)
          • ✅ Health & Safety in Educational Settings Certification`,

          founderJourney:
            "Her professional journey is anchored in evidence-based interventions and whole-child support approaches, empowering schools to implement effective IEPs, behavior plans, and early intervention strategies.",

          founderAuthorHeading: "Author & Educational Reformer",
          founderAuthorList: `1. Dear Teacher, I Am Not Broken  
            A heartfelt call to educators to see beyond labels and connect with the child inside every student.

          2. Neurodiverse Classrooms: A Teacher’s Guide to SEN Support  
            A practical, accessible guide packed with inclusive strategies, tools, and frameworks for teachers and SENCOs.

          3. Beyond Gifted: Supporting Talented and Twice-Exceptional Learners in Our Neurodiverse World  
            A groundbreaking work exploring the needs of gifted and twice-exceptional (2e) learners and how schools can truly nurture their potential.

          In addition, she created the #MyDearTeacher Advocacy & Resource Toolkit, a downloadable, school-ready pack designed to help teachers create more inclusive, empathetic, and neurodivergent-affirming learning environments.`,

          founderImpactHeading: "🌍 Global Impact & Advocacy",
          founderImpactList: `• SDG 4 – Quality Education for All  
          • SDG 10 – Reduced Inequalities in Learning Access and Outcomes`,

          founderImpactText:
            "Her work bridges grassroots classroom realities with global education policy reform. She collaborates with educators, ministries, NGOs, and parent organizations to create lasting change in education systems across Africa, the Middle East, and beyond.",

          founderCallingHeading: "❤️ A Personal Calling",
          founderCallingText: `Beauty Tommy’s work is deeply rooted in empathy, lived experience, and professional excellence. Having witnessed the impact of exclusion and misunderstanding on children with diverse learning needs, she set out to ensure that no child would ever feel invisible and no teacher unsupported.

          Today, through the #MyDearTeacher Movement, she continues to lead with courage, compassion, and conviction, bridging the gap between policy and practice, between heart and handbook. Whether through writing, mentoring, speaking, or volunteering, Amb. Beauty’s work is driven by one unwavering belief:
          “Every child deserves a space to belong, a voice to be heard, and a teacher who believes in them.”`,

                  // in your i18n.js → resources.en.translation
          founderJourney: `Her professional journey is anchored in evidence-based interventions
          and whole-child support approaches, empowering schools to implement effective
          IEPs, behavior plans, and early intervention strategies.`,

          /* ─── STUDENT SPACE ─── */
         // ─── STUDENT SPACE (English) ───
          studentSpaceTitle: "Dear Student Space",
          studentSpaceIntro: "A Safe Space to Be Heard, Seen & Celebrated. Welcome to the Dear Student Space, where your voice matters. Whether you’re neurodivergent, gifted, twice-exceptional, or simply navigating life in school, this space is made for you.",
          studentSpaceSubmitHeading: "📧 Submit Your Letter or Artwork",
          studentSpaceSubmitDesc: " ",
          studentSpaceAttachLetter: "A typed or handwritten letter",
          studentSpaceAttachDrawing: "A drawing or artwork",
          studentSpaceAttachVoice: "A voice note (optional)",
          studentSpaceAnonymous: "You can choose to remain anonymous. Some letters may be shared (with permission) in our upcoming Student Voices Gallery.",
          studentSpaceTemplateHeading: "📝 Download the Student Letter Template",
          studentSpaceTemplateDesc: "Want help writing? Download our Dear Teacher Letter Template (PDF).",
          studentSpaceTemplateBtn: "Download Template (PDF)",
          studentSpaceGalleryHeading: "🖼️ Coming Soon: Student Voices Gallery",
          studentSpaceGalleryDesc: "We’re building a gallery of real student stories—letters, drawings, and art shared by amazing students like you! You could be featured! 🌟",
          studentSpaceConsentHeading: "✅ Consent & Safety",
          studentSpaceConsentText: "If you are under 18, please make sure your parent, caregiver, or teacher knows you’re submitting a letter. All submissions are treated with respect, confidentiality, and care. We won’t publish your name, school, or photo unless you’ve given permission.",
          studentSpaceFounderQuote: "To every student reading this: I see you. I believe in you. You are not broken—you are brilliant. And you deserve a world that sees your light.",
          studentSpaceMailClubHeading: "📬 Want to Receive Letters Too?",
          studentSpaceMailClubDesc: "Sign up to our Student Mail Club to get inspirational letters from teachers, other students, and the #MyDearTeacher team.",
          studentSpaceMailClubBtn: "Join the Mail Club (coming soon)",
          studentSpaceMailClubInteractive:
          "Members will also get access to an interactive section where they can chat and connect with each other on our platform.",
          
          /* ─── BLOG ─── */
                  // ─── BLOG (English) ───
          blogTitle: "Student & Teacher Stories",
          story1Body: `Jayden didn’t fit the mold.
          He was nine, wildly gifted in math, able to solve equations that made adults pause. But every day in school was a battle—not because of the content, but because of the expectations.

          He couldn’t sit still. He’d interrupt, lose focus, bounce his leg for hours. Teachers said he was “too much,” “too distracted,” or “just not trying hard enough.” But he was trying every single day to exist in a world that didn’t know how to meet a gifted brain wrapped in ADHD.

          Then came Ms. Leena. She didn’t see Jayden as a disruption. She saw him as a thinker. She moved his desk near a window, gave him a fidget, and introduced “math leadership moments” where Jayden could help solve tricky puzzles on the board. She didn’t punish movement—she planned for it.

          One day, she told him, “You don’t have to shrink to fit this room. Let’s stretch the room to fit you.” For the first time, Jayden didn’t feel broken. He felt brilliant. Now he wants to be a mathematician who helps design classrooms for kids like him. Because one teacher didn’t try to fix him—she chose to understand him.`,

          story2Body: `Maya spoke in colors. She didn’t speak much with words, not in the way the classroom expected. On most days, she kept to herself, her voice hidden beneath the weight of sensory overload and social anxiety.

          Other students called her shy. Some called her strange. But in the back of her notebook, Maya was telling stories no one had ever seen—vivid, detailed drawings of fantasy worlds, soft moments, silent heroes who felt… just like her.

          That’s when Ms. Adu noticed. Instead of asking Maya to speak up, she invited her to share her art in a new way. The class began “Story Through Sketch,” a project where everyone wrote short tales inspired by Maya’s drawings. Slowly, Maya began sharing titles, then captions, then full sentences. And one morning, with her heart pounding and her artwork glowing on the projector, Maya read aloud, “This is my world. And I want you in it.”

          Today, Maya writes illustrated stories about girls who build dream machines and save gentle monsters. She says they’re based on people she knows—like Ms. Adu.`,

          story3Body: `Aliyah was a quiet storm. On the surface, she was withdrawn. But inside, everything was loud—the fluorescent lights, the ticking clock, the screech of chairs on tile. Her world didn’t feel safe. It felt overwhelming.

          She’d try her best until it was too much. And then came the shutdowns, the tears, the blank stares. Most teachers saw behavior. Mr. Joseph saw a signal. He introduced something simple yet revolutionary: a calm corner. Soft lights. Weighted cushions. Noise-canceling headphones. A “take-a-break” pass students could use without asking.

          For the first time, Aliyah had a space that honored her needs without shame. Bit by bit, she re-entered the classroom on her own terms—raising her hand, helping a peer, smiling. The calm corner wasn’t a reward. It was a right. It was belonging made visible.

          Aliyah says her classroom feels like home now. And Mr. Joseph? He says, “Every child should know: You are not wrong for feeling differently. There is room for you here.”`,

                    /* ─── BOOKS ─── */
                    // ─── BOOKS (English) ───
          booksTitle: "Our Books",
          booksIntro:
            "Explore the powerful resources, insights, and stories shaping the future of inclusive education through the #MyDearTeacher Movement.",

          book1Title: "Neurodiverse Classrooms",
          book1Subtitle: "A Teacher’s Guide to SEN Support",
          book1Desc:
            "A go-to guide filled with practical tools and strategies for supporting neurodiverse learners.",
          book1Blurb: `In every classroom, there’s more than one way to learn—and more than one way to thrive. Neurodiverse Classrooms is more than a book; it’s a call to action for every educator who wants to create spaces where every learner feels seen, safe, and supported.

          Written with compassion and clarity, this guide equips teachers with the tools, mindset, and strategies needed to confidently support students with Special Educational Needs (SEN). It blends evidence-based practices with real classroom experiences, offering practical ideas that can be used immediately, even in under-resourced settings.

          🔹 Inside the Book:
          • Understanding Neurodiversity: Breaks down the different types of SEN and what they might look like in everyday classrooms.
          • Creating Inclusive Environments: Guidance on classroom layout, routines, visuals, and transitions that work for diverse learners.
          • Practical SEN Strategies: Targeted tips for supporting speech and language needs, autism, ADHD, learning difficulties, and more.
          • Teacher Self-Care and Advocacy: Because teachers need support too.

          Whether you’re new to inclusion or simply want to do better, this guide will walk with you—every step of the way.`,

          book2Title: "Beyond Gifted",
          book2Subtitle: "Supporting Talented and Twice-Exceptional Learners in Our Neurodiverse World",
          book2Desc:
            "This groundbreaking book bridges the gap between gifted education and neurodiversity.",
          book2Blurb: `Gifted doesn’t mean perfect. And twice-exceptional learners—those who are gifted and neurodivergent—are often among the most misunderstood in our schools. Beyond Gifted is a gentle yet powerful guide that helps educators, parents, and caregivers understand and support 2e learners with both their strengths and struggles in mind.  

          🔹 Inside the Book:
          • Who Are 2e Learners?: Understanding dual-exceptionality and its academic, emotional, and behavioral expressions.
          • Strengths-Based Teaching: How to stretch talent while scaffolding challenges.
          • Emotional Wellness: Supporting the identity, confidence, and mental health of twice-exceptional children.
          • Parent and Teacher Collaboration: Bridging school-home gaps for better outcomes.
          • Global Case Studies: Real voices from across the world sharing success stories and lessons learned.  

          This book is an invitation to stop asking, “What’s wrong with this child?” and start asking, “What’s possible if we support them right?”`,

          book3Title: "Dear Teacher, I Am Not Broken",
          book3Subtitle: "Poetic insights that sparked a movement.",
          book3Desc:
            "A poetic, heart-opening narrative that gives voice to misunderstood learners.",
          book3Blurb: `What if students could write letters to their teachers—not in protest, but in truth? Dear Teacher, I Am Not Broken is a deeply moving and eye-opening collection of reflections written from the perspective of children who learn differently. Through each page, it gives voice to the often-silent pain and resilient spirit of neurodivergent learners across the globe.  

          🔹 Inside the Book:
          • Student Letters: Heartfelt messages expressing frustration, hope, confusion, and gratitude.
          • Reflection Points for Educators: Prompts to encourage compassionate teaching and deeper empathy.
          • What I Wish You Knew Sections: Insightful notes that help adults truly “see” the child.
          • Try Tomorrow Tips: Practical actions teachers and parents can take right away.  

          This book is a love letter—and a wake-up call—to the education system.`,

          book4Title: "#MyDearTeacher Toolkit",
          book4Subtitle: "Advocacy & Resource Guide for Inclusive Classrooms",
          book4Desc:
            "A practical toolkit with checklists, templates, and inclusion frameworks.",
          book4Blurb: `Inclusion is not a buzzword—it’s a commitment. The #MyDearTeacher Toolkit is your all-in-one printable and practical companion to advocating for neurodiverse learners in any classroom, home, or community space.  

          🔹 Inside the Toolkit:
          • Advocacy Letters & Templates: Pre-written forms and guides for IEP meetings, school requests, and support documentation.
          • Student Voice Activities: Templates and prompts for children to express their needs, gifts, and goals.
          • Educator Quick Tips: Behavior support strategies, inclusive teaching ideas, sensory-friendly setup hacks.
          • Global Resource Directory: A curated list of tools, apps, support centers, and organizations for inclusive education.
          • Campaign Materials: Flyers, posters, and scripts to help spread the message of inclusion.  

          Whether you’re a teacher, parent, or student advocate—this is your invitation to join a movement that’s changing how the world sees and supports neurodivergent learners.`,

          buyNow: "Buy Now",
          bookReadMore: "Read More",
          bookReadLess: "Show Less",
          bookBuySoon: "Books are under review and will be available soon.",
          booksContactText: "📦 Want to order or partner with us?",
          getInTouch: "Get in Touch",

          /* ─── EVENTS ─── */
         // ─── EVENTS (English) ───
          eventsTitle: "Events & Workshops",
          eventsUpcoming: "Upcoming",
          eventsPast: "Past",
          eventsRegister: "Register",
          eventsNone: "No events in this category yet. Check back soon!",

          /* ─── JOIN US ─── */
         // ─── JOIN US (English) ───
          joinUsTitle: "Join the #MyDearTeacher Movement",
          joinUsIntro: "Whether you're a teacher, parent, policymaker, or passionate advocate, there's a place for you in this movement. Together, we’re building a world where every child feels seen, supported, and celebrated.",
          joinUsName: "Your Name",
          joinUsEmail: "Your Email",
          joinUsRole: "Your Role",
          joinUsSelectRole: "Select your role",
          joinUsParent: "Parent",
          joinUsEducator: "Educator",
          joinUsNGO: "NGO / Partner",
          joinUsOther: "Other",
          joinUsBtn: "Join Now",
          joinUsSuccess: "✅ Thank you for joining the movement!",
          joinUsReady: "✨ Ready to get started?",
          joinUsEmailText: "Email us at",
          joinUsFollow: "Follow us:",

          // ─── CONTACT (English) ───
          contactTitle: "Contact Us",
          contactIntro: "We’d love to hear from you. Whether it’s a question, invitation, or partnership request, reach out and let’s build something beautiful together.",
          contactName: "Your Name",
          contactEmail: "Email",
          contactMessage: "Message",
          contactBtn: "Send Message",
          contactSuccess: "💌 Your message has been sent! Thank you.",
          contactDetailsEmail: "Email:",
          contactDetailsWebsite: "Website:",

          // ─── FOOTER (English) ───
          footerAbout: "© 2025 #MyDearTeacher Movement. All rights reserved.",
          footerFollow: "Follow Us",
          footerContactEmail: "Email: info@mydearteachermovement.com",
          footerContactWebsite: "Website: mydearteachermovement.com",
          footerPrivacy: "Privacy Policy",
          footerTerms: "Terms of Service",

        }
      },

      /* ─────────────────── ARABIC ─────────────────── */
      ar: {
        translation: {
          /* same keys as above, with Arabic values */

          // ─── شريط التنقل ───

          // Arabic
          navHome: "الرئيسية",
          navMission: "مهمتنا",
          navFounder: "المؤسسة",
          navStudentSpace: "مساحة الطالب",
          navAbout: "من نحن",
          navBooks: "الكتب",
          navEvents: "فعاليات",
          navJoin: "انضم إلينا",
          navContact: "تواصل معنا",
          navBlog: "المدونة",

          // ─── الصفحة الرئيسية ───
          homeTagline1: "واحد من كل خمسة طلاب يختلفون عصبيًا.",
          homeTagline2: "الإدماج ليس خيارًا إضافيًا—بل ضرورة.",
          homeTagline3: "كل طفل يستحق أن يُرى.",
          homeWelcomeTitle: "إعادة تخيل التعليم لكل طفل",
          homeWelcomeText: "لأن لا أحد مكسور. انضم إلينا لبناء فصول ترى كل طفل — ليس كمشكلة تُصلح، بل كقصة تُفهم.",
          homeGalleryTitle: "📸 لحظات وأصوات من الحركة",
          homeWatchTitle: "🎥 شاهد مقاطع الفيديو",
          homeWatchDesc: "اكتشف رسالتنا من خلال قصص بصرية مؤثرة ورؤى تربوية.",
          homeExploreBtn: "استكشف الأدوات",
          homeAuthorBtn: "قابل المؤلفة",
          homeFounderBtn: "قابل المؤسسة",
          homeStudentSpaceBtn: "مساحة الطالب",
          homeVideoBtn: "شاهد فيديو الحركة",
          // ─── المهمة والرؤية (Arabic) ───
          missionVisionTitle: "المهمة والرؤية",

          missionHeading: "مهمتنا",
          missionIntro:
          "مهمة حركة #MyDearTeacher هي تحويل أنظمة التعليم العالمية من خلال تبنّي ممارسات شاملة ومليئة بالتعاطف وتؤكد على التنوع العصبي. نزوّد المعلمين والمدارس والمجتمعات بالأدوات والفهم والعقلية اللازمة لضمان أن يُرى كل طفل، ويحظى بالدعم، ويُحتفى به.",
          missionPoint1:
          "تمكين المعلمين من خلال استراتيجيات عملية قائمة على الأدلة للتعليم الشامل ودعم ذوي الاحتياجات الخاصة.",
          missionPoint2:
          "رفع أصوات المتعلمين العصبييّ الاختلاف، والموهوبين، وذوي الاستثنائية المزدوجة الذين غالبًا ما يُساء فهمهم أو تُهمش أصواتهم.",
          missionPoint3:
          "الدفاع عالميًا عن سياسات تعليمية عادلة، وأُطر دمج على مستوى المدرسة، وتدريب مستدام للمعلمين.",
          missionPoint4:
         "خلق مساحات عاطفية آمنة يشعر فيها المعلمون بالاحترام والطلاب بالتقدير.",
          missionPoint5:
          "الاحتفال بمهنة التعليم كمهمة مقدسة—المعلمون هم المربّون والحماة والمدافعون في الصفوف الأمامية.",
          missionClosing:
         "التعليم الشامل حق من حقوق الإنسان، وليس رفاهية. يجمع عملنا بين البحث والواقع في الفصول الدراسية حتى لا يشعر أي معلم بالتوحّد ولا يشعر أي طفل بأنه مكسور.",

         visionHeading: "رؤيتنا",
          visionIntro:
         "نحن نتخيل نظامًا تعليميًا عالميًا تكون فيه الشمولية مبدأً أساسيًا يوجّه كل درس وسياسة وتفاعل.",
         visionPoint1:
         "يزدهر المتعلمون العصبيو التنوع في مدارس تعترف بإمكاناتهم وتوفر مسارات مخصصة للنجاح.",
         visionPoint2:
          "يحظى المعلمون بدعم كامل من الموارد العاطفية والنفسية والمهنية لمنع الإرهاق.",
         visionPoint3:
         "يصبح الآباء والمجتمعات شركاء في رحلة التعلم، مما يعزز الثقة والدفاع والتمكين.",
         visionPoint4:
          "تنتقل أنظمة المدارس من نماذج “مقاس واحد يناسب الجميع” إلى أُطر مرنة تركز على الإنسان ومتوافقة مع التصميم العالمي للتعلم.",
          visionPoint5:
          "تقدّر المجتمعات الذكاء العاطفي والتنوّع العصبي كتنوع يستحق الاحترام.",
          visionSDGIntro:
          "ندعم أهداف التنمية المستدامة للأمم المتحدة:",
          sdg4:
          "التعليم الجيد – توفير فرص تعلم شاملة ومنصفة للجميع.",
          sdg10:
          "الحد من عدم المساواة – تمكين الفئات المهمشة وإزالة العقبات النظامية.",
          visionClosing:
          "نرى فصولًا دراسية في كل قارة—ريفية أو حضرية، حكومية أو خاصة—حيث تكون الرسالة واضحة: كل طفل ينتمي. كل معلم مهم. كل صوت له قيمة.",
          // ─── حول الحركة (Arabic) ───
          aboutTitle: "عن حركة #MyDearTeacher",
          aboutIntro:
            "حركة #MyDearTeacher هي مبادرة عالمية تغيّر طريقة رؤيتنا ودعمنا واحتفالنا بالمتعلمين العصبيي التنوع.",
          aboutFounderName: "السفيرة بيوتي تومي، ماجستير في علم النفس التربوي",
          aboutFounderCred1: "سفيرة الأمم المتحدة للسلام",
          aboutFounderCred2: "عالمة نفس تربوي",
          aboutFounderCred3: "ناشطة في مجال الدمج",

          aboutOriginTitle: "📘 قصتنا",
          aboutTimeline2019:
            "2019 – ألهمت قصيدة «عزيزي المعلم، أنا لست مكسورًا» نقاشًا عالميًا حول التنوع العصبي.",
          aboutTimeline2022:
            "2022 – شراكات تجريبية مع أكثر من 40 مدرسة في أفريقيا والشرق الأوسط لتضمين أُطر شاملة.",
          aboutTimeline2025:
            "2025 – إطلاق مجموعة أدوات #MyDearTeacher ومساحة الطالب، لتمكين أكثر من 10000 معلم حول العالم.",

          aboutMissionTitle: "🎯 مهمتنا",
          aboutMission:
            "تمكين وإلهام المعلمين للتدريس بالتعاطف والثقة حتى يزدهر كل طالب في بيئات شاملة وداعمة.",

          aboutVisionTitle: "👁 رؤيتنا",
          aboutVision:
            "مستقبل لا يُوصَف فيه أي متعلم كمكسور، وتصبح كل فصولنا مكانًا للانتماء والنمو والإمكانات.",

          aboutSDGTitle: "🌐 الأثر العالمي وأهداف التنمية",
          aboutImpactLabel: "لمحة عن الأثر:",
          aboutImpactStat1: "📚 أكثر من 25000 كتابًا وُزّع في الفصول الدراسية",
          aboutImpactStat2: "👩‍🏫 أكثر من 12000 معلم تلقوا تدريبًا في ممارسات شاملة",

          aboutWorkTitle: "💼 ماذا نفعل",
          aboutBooks: "📚 كتب ومنشورات تشعل الحوار",
          aboutTraining: "👩🏽‍🏫 تدريب المعلمين وأدلة الدمج",
          aboutCampaigns: "🎤 حملات ومناصرة رقمية ومباشرة",
          aboutPartnerships: "🏫 شراكات مع المدارس للدمج",
          aboutEngagement: "📣 مشاركة الشباب وأولياء الأمور – أصوات مؤثرة",

          aboutPartnersTitle: "🤝 لماذا الشراكات مهمة",
          aboutPartners:
            "يحدث التغيير عبر التعاون مع المدارس والمنظمات غير الحكومية والجهات المتفقة مع أهداف الأمم المتحدة.",

          aboutJoinTitle: "🌟 انضم إلى الرحلة",
          aboutOffer1: "برامج التطوير المهني",
          aboutOffer2: "الاستشارات وأُطر الدمج",
          aboutOffer3: "الظهور العالمي عبر الحملات",
          aboutOffer4: "الدعوة المبنية على البحث في الحياة الواقعية",
          // in your i18n.js → resources.ar.translation
          founderJourney: `مسيرتها المهنية مدعومة بالتدخلات القائمة على الأدلة ونهج دعم الطفل الكامل،
          مما يمكّن المدارس من تنفيذ خطط التعليم الفردية (IEPs)، وخطط السلوك، واستراتيجيات
          التدخل المبكر.`,

          // ─── المؤسسة (Arabic placeholders) ───
                    // inside resources.ar.translation:
          founderTitle: "عن المؤسسة",
          founderTagline:
            "السفيرة بيوتي تومي، ماجستير في علم النفس التربوي | RBT | IBT | مناصرة الدمج | سفيرة أهداف التنمية المستدامة",
          founderBioIntro:
            "السفيرة بيوتي تومي هي أخصائية نفس تربوي معترف بها عالميًا، مستشارة توجيهية، ومدافعة عن الإدماج لديها خبرات واسعة في تحويل أنظمة التعليم لخدمة كل متعلم بكرامة وتعاطف. وهي المؤسسة والرؤية وراء حركة #معلمي_العزيز العالمية.",
          founderCredHeading: "🎓 المؤهلات والشهادات",
          founderCredList: `• ✅ فني سلوك معتمد (RBT)
          • ✅ معالج سلوك دولي (IBT)
          • ✅ دبلوم في العلاج السلوكي المعرفي
          • ✅ دبلوم في علم النفس الإيجابي
          • ✅ دبلوم في علم نفس الطفل
          • ✅ دبلومات معتمدة من KHDA في الاحتياجات التعليمية الخاصة والتعليم المبكر
          • ✅ شهادة في الصحة والسلامة في البيئات التعليمية`,
          founderJourney:
            "رحلتها المهنية ترتكز على تدخلات قائمة على الأدلة ونهج دعم الطفل ككل، مما يمكّن المدارس من تنفيذ خطط التعليم الفردية وخطط السلوك واستراتيجيات التدخل المبكر الفعّالة.",
          founderAuthorHeading: "مؤلفة ومُصلحة تعليمية",
          founderAuthorList: `1. Dear Teacher, I Am Not Broken
          رسالة مؤثرة تدعو المعلمين لرؤية الطفل وراء التصنيفات.

          2. Neurodiverse Classrooms: A Teacher’s Guide to SEN Support
          دليل عملي مليء باستراتيجيات وأدوات شاملة للمعلمين ومنسقي الاحتياجات الخاصة.

          3. Beyond Gifted: Supporting Talented & Twice-Exceptional Learners
          عمل رائد حول احتياجات المتعلمين الموهوبين والمزدوجي الاستثناء وكيفية رعايتهم.`,
          founderImpactHeading: "🌍 الأثر والمناصرة العالمية",
          founderImpactList: `• الهدف 4 – التعليم الجيّد للجميع
          • الهدف 10 – الحدّ من أوجه عدم المساواة في فرص التعلم`,
          founderImpactText:
            "عملها يجسر بين واقع الفصول الدراسية والسياسات العالمية، متعاونة مع وزارات ومنظمات غير حكومية وهيئات أولياء الأمور عبر أفريقيا والشرق الأوسط وخارجها.",
          founderCallingHeading: "❤️ دعوة شخصية",
          founderCallingText:
            "عمل بيوتي تومي ينبع من التعاطف والخبرة المهنية. بعد أن شهدت أثر الاستبعاد على المتعلمين المتنوعين، كرست جهودها لضمان ألا يشعر أي طفل بالاختفاء ولا أي معلّم بالوحدة.\n\n“كل طفل يستحق مساحة للانتماء، وصوتاً يُسمع، ومعلّماً يؤمن به.”",

          // ─── مساحة الطالب (Arabic) ───
          studentSpaceTitle: "مساحة الطالب",
          studentSpaceIntro:
            "مساحة آمنة لتُسمع وتُرى وتُحتفى بك. مرحبًا بك في مساحة الطالب، حيث صوتك مهم. سواء كنت عصبي التنوع، موهوبًا، ذو استثنائية مزدوجة، أو ببساطة تتنقل في الحياة المدرسية، هذه المساحة مصممة من أجلك.",
          studentSpaceSubmitHeading: "📧 أرسل رسالتك أو عملك الفني",
          studentSpaceSubmitDesc:
            "أرسل رسالتك عبر البريد الإلكتروني: info@mydearteachermovement.com",
          studentSpaceAttachLetter: "رسالة مطبوعة أو مكتوبة بخط اليد",
          studentSpaceAttachDrawing: "رسم أو عمل فني",
          studentSpaceAttachVoice: "ملاحظة صوتية (اختياري)",
          studentSpaceAnonymous:
            "يمكنك اختيار البقاء مجهول الهوية. قد يتم مشاركة بعض الرسائل (بإذن مسبق) في معرض أصوات الطلاب القادم.",
          studentSpaceTemplateHeading: "📝 تحميل نموذج رسالة الطالب",
          studentSpaceTemplateDesc:
            "تحتاج مساعدة في الكتابة؟ قم بتنزيل نموذج رسالة الطالب أدناه.",
          studentSpaceTemplateBtn: "تحميل النموذج (PDF)",
          studentSpaceGalleryHeading: "🖼️ قريبًا: معرض أصوات الطلاب",
          studentSpaceGalleryDesc:
            "نحن نبني معرضًا لقصص الطلاب الحقيقية—رسائل، رسومات، وفنون يشاركها طلاب رائعون مثلك! قد تكون أنت من يُعرض عمله! 🌟",
          studentSpaceConsentHeading: "✅ الموافقة والسلامة",
          studentSpaceConsentText:
            "إذا كان عمرك أقل من 18 عامًا، يرجى التأكد من علم ولي الأمر أو المعلم بإرسال رسالتك. جميع المساهمات تعامل باحترام وسرية وعناية. لن ننشر اسمك أو مدرستك أو صورتك دون إذن.",
          studentSpaceFounderQuote:
            "لكل طالب يقرأ هذا: أراكم. أؤمن بكم. أنتم لستم مكسورين—أنتم رائعون. وتستحقون عالمًا يرى نوركم.",
          studentSpaceMailClubHeading: "📬 هل تريد تلقي الرسائل أيضًا؟",
          studentSpaceMailClubDesc:
            "انضم إلى نادي بريد الطلاب للحصول على رسائل ملهمة من المعلمين والطلاب وفريق #MyDearTeacher.",
          studentSpaceMailClubBtn: "انضم إلى النادي (قريبًا)",
          studentSpaceMailClubDesc: "…",
          studentSpaceMailClubInteractive: "سيحصل الأعضاء أيضًا على وصول إلى قسم تفاعلي حيث يمكنهم الدردشة والتواصل مع بعضهم البعض على منصتنا.",
          studentSpaceMailClubBtn: "انضم إلى النادي (قريبًا)",
                // ─── المدونة (Arabic placeholders) ───
          blogTitle: "قصص الطلاب والمعلمين",
          story1Body: "…",
          story2Body: "…",
          story3Body: "…",

          // ─── الكتب (Arabic placeholders) ───
          booksTitle: "…",
          booksIntro: "…",
          book1Title: "…",
          book1Subtitle: "…",
          book1Desc: "…",
          book1Blurb: "…",
          book2Title: "…",
          book2Subtitle: "…",
          book2Desc: "…",
          book2Blurb: "…",
          book3Title: "…",
          book3Subtitle: "…",
          book3Desc: "…",
          book3Blurb: "…",
          book4Title: "…",
          book4Subtitle: "…",
          book4Desc: "…",
          book4Blurb: "…",
          buyNow: "…",
          bookReadMore: "…",
          bookReadLess: "…",
          bookBuySoon: "…",
          booksContactText: "…",
          getInTouch: "…",
          // ─── الفعاليات وورش العمل (Arabic) ───
          eventsTitle: "الفعاليات وورش العمل",
          eventsUpcoming: "القادمة",
          eventsPast: "السابقة",
          eventsRegister: "تسجيل",
          eventsNone: "لا توجد فعاليات في هذه الفئة حالياً. تحقق لاحقاً!",
          // ─── انضم إلينا (Arabic) ───
          joinUsTitle: "انضم إلى حركة #MyDearTeacher",
          joinUsIntro: "سواء كنت معلمًا أو ولي أمر أو صانع سياسات أو مدافعًا شغوفًا، هناك مكان لك في هذه الحركة. معًا نبني عالمًا يشعر فيه كل طفل بأنه مرئي ومدعوم ومحتفى به.",
          joinUsName: "اسمك",
          joinUsEmail: "بريدك الإلكتروني",
          joinUsRole: "دورك",
          joinUsSelectRole: "اختر دورك",
          joinUsParent: "ولي أمر",
          joinUsEducator: "معلم/ـة",
          joinUsNGO: "منظمة/شريك",
          joinUsOther: "أخرى",
          joinUsBtn: "انضم الآن",
          joinUsSuccess: "✅ شكرًا لانضمامك إلى الحركة!",
          joinUsReady: "✨ هل أنت مستعد للبدء؟",
          joinUsEmailText: "راسلنا عبر البريد:",
          joinUsFollow: "تابعنا على:",
// ─── تواصل معنا (Arabic) ───
          contactTitle: "تواصل معنا",
          contactIntro: "يسعدنا أن نسمع منك. سواء كان سؤالًا أو دعوة أو طلب شراكة — تواصل معنا ولنصنع معًا شيئًا جميلًا.",
          contactName: "اسمك",
          contactEmail: "البريد الإلكتروني",
          contactMessage: "رسالتك",
          contactBtn: "إرسال الرسالة",
          contactSuccess: "💌 تم إرسال رسالتك! شكرًا لك.",
          contactDetailsEmail: "البريد الإلكتروني:",
          contactDetailsWebsite: "الموقع:",

                    // ─── التذييل (Arabic) ───
          footerAbout: "© 2025 حركة #MyDearTeacher. جميع الحقوق محفوظة.",
          footerFollow: "تابعنا",
          footerContactEmail: "البريد الإلكتروني: info@mydearteachermovement.com",
          footerContactWebsite: "الموقع: mydearteachermovement.com",
          footerPrivacy: "سياسة الخصوصية",
          footerTerms: "شروط الخدمة",


                  }
      }
    }
  });

export default i18n;
